import { FC } from 'react'
import { useAccount } from 'wagmi'

import { useIsMounted } from '../../hooks'
import { Button } from '../WalletButton/Button'
import { CheckerButton } from './types'

export const Connected: FC<CheckerButton> = ({ children, className, variant, fullWidth, size, name, onBlur, as, color }) => {
  const isMounted = useIsMounted()
  const { address } = useAccount()

  if (isMounted && !address)
    return (
      <div className="animate-border hover:animate-none group-one-hover:animate-none group-hover:animate-none duration-500 ease-in-out flex flex-col gap-2 space-y-2 rounded-[1.1rem] bg-gradient-to-r from-gradientborderone via-gradientbordertwo to-gradientborderthree bg-[length:200%_200%] p-[1px] transition focus:outline-none">
        <Button
          color={color}
          appearOnMount={false}
          className={className}
          variant={variant}
          fullWidth={fullWidth}
          size={size}
          name={name}
          as={as}
          onBlur={onBlur}
        >
          Connect Wallet
        </Button>
      </div>
    )

  return <>{children}</>
}
